/**
 * Light/dark toggle.
 *
 * The palette picker that shipped here is gone. It was a good demonstration of
 * the token system and the wrong control for a product: an operator should not
 * be able to change the brand, and a stored variant silently overrode the real
 * palette during development until we caught it.
 *
 * Dark mode stays, and matters — this is a console people keep open all day.
 */
import { Button, Tooltip, TooltipTrigger, TooltipContent, useTheme } from '@bloomneo/uikit';
import { Moon, Sun } from 'lucide-react';

export function ThemeControls() {
  const { mode, setMode } = useTheme();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="size-8"
          aria-label={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          onClick={() => setMode(mode === 'dark' ? 'light' : 'dark')}
        >
          {mode === 'dark' ? <Sun className="size-4" /> : <Moon className="size-4" />}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{mode === 'dark' ? 'Light mode' : 'Dark mode'}</TooltipContent>
    </Tooltip>
  );
}
